import { render, staticRenderFns } from "./BuildingUnityViewerTab.vue?vue&type=template&id=35b54ddf"
import script from "./BuildingUnityViewerTab.vue?vue&type=script&lang=ts"
export * from "./BuildingUnityViewerTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports